import { CurrencyPipe, DatePipe } from "@angular/common";
import { SplitInterpolation, ThrowStmt } from "@angular/compiler";
import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { errorMonitor } from "events";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { element } from "protractor";
import { Observable, Subscription, zip } from "rxjs";
import { first, map, tap } from "rxjs/operators";
import { CesionFilter } from "src/app/models/Cesion/CesionFilter";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { Traza } from "src/app/models/Traza";
import { CesionService } from "src/app/services/cesion.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { ConfigMantenedorCesion } from "./config-mantenedor-cesion";
import * as FileSaver from "file-saver";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { EmailData } from "src/app/shared/models/EmailData";
import { EmailAttachment } from "src/app/shared/models/EmailAttachment";
import { MultipleEmailValidator } from "src/app/directives/multi-email.directive";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { Response } from "src/app/shared/models/Response";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { PermissionService } from "src/app/services/permission.service";
import { NotaDebito } from "src/app/models/NotaDebito";
import { Cesion } from "src/app/models/Cesion/Cesion";
import { TipoDte } from "src/app/models/tipoDte";
import { TrazaCesion } from "src/app/models/Cesion/TrazaCesion";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { SortType } from "@swimlane/ngx-datatable";
import { UpdateCesionRequest } from "src/app/models/Cesion/UpdateCesionRequest";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-mantenedor-cesion",
	templateUrl: "./mantenedor-cesion.component.html",
	styleUrls: ["./mantenedor-cesion.component.scss"],
})
export class MantenedorCesionComponent implements OnInit {
	SortType = SortType;
	public tracesModal: NgbModalRef;
	public anuladorModal: NgbModalRef;
	public sendercesionModal: NgbModalRef;
	public detailModal: NgbModalRef;
	loading: boolean = false;
	public configLocal = ConfigMantenedorCesion;
	public rowsMantenedor: Cesion[] = [];
	public selected: Cesion[] = []; //cesions seleccionados por checkbox
	public selectedItem: Cesion; //cesion seleccionado para envio individual y despliegue en modal
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public searchRows: any[] = [];
	public searchCriteria;
	fileIdState: Observable<object>;
	fileIdValue: string;
	registrationIdValue: string;
	receptorRutString: string;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public emisorId: string;
	public empresasSource;
	public tipocesionSource: TipoDte[];
	public page = new Page();
	public filter = new CesionFilter();
	public trazasCesionToShow: TrazaCesion[] = [];
	public cesionToShow: Cesion = new Cesion();
	public cesionToNullify: Cesion = new Cesion();
	public cesionToNullifyReferences: Cesion[] = [];
	public senderForm: FormGroup;
	public idGuide = "";
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	@ViewChild("notesSwal") private notesSwal: SwalComponent;
	public filterDescription: string;
	public componentStarted: boolean = false;
	@ViewChild("tableMobile") tableRef: any;
	private closeActionsHandler: any;
	constructor(
		public activatedRoute: ActivatedRoute,
		private cesionService: CesionService,
		private dteService: DteEmitidosService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		private localStorage: LocalStorageService,
		public utilities: UtilitiesService,
		private modalService: NgbModal,
		private datePipe: DatePipe,
		private currencyPipe: CurrencyPipe,
		private formBuilder: FormBuilder,
		private formConfig: FormrulesConfigService,
		public permissions: PermissionService,
		private router: Router,
		private sessionUserService: SessionUserService
	) {
		this.emisorId = this.tokenService.getCompany();

		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.checkStateId();
		this.starterPage();
		this.filter.emisorId = this.emisorId;
	}

	checkStateId() {
		this.fileIdState = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.setPage({ offset: 0 });
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
	
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
	  


	ngAfterViewInit() {}
	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}

	detailOpenModal(modalRef, row: Cesion) {
		this.cesionToShow = row;
		this.loading = true;
		this.cesionService
			.getDteCesion(row.cesionId)
			.subscribe(
				(res) => {
					this.cesionToShow.dte = res.data;
				},
				(err) => {
					this.setSwalAndFire(this.currentSwal, "error", "Error al obtener DTE", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
				}
			)
			.add(() => {
				this.cesionService
					.getDetalleCesion(row.cesionId)
					.subscribe(
						(res) => {
							this.cesionToShow.detalles = res.data;
						},
						(err) => {
							this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
						}
					)
					.add(() => {
						this.loading = false;
						this.ref.detectChanges();
						this.detailModal = this.modalService.open(modalRef, {
							windowClass: "",
							size: "lg",
							centered: true,
						});
					});
			});
	}

	searchElements(emisorId: string) {
		this.loading = true;
		this.cesionService.getDataByPage(this.filter, this.page).subscribe(
			(result) => {
				let elements = result.data as Cesion[];
				elements.forEach((row) => {});
				this.rowsMantenedor = [...elements];
			},
			(error) => {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en la solicitud";
				this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	ngOnDestroy() {
		this.fileIdState = undefined;
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	getId(row) {
		return row.cesionId;
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((cesion) => {
					this.selected = this.selected.filter((selectedcesion) => selectedcesion.cesionId !== cesion.cesionId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((cesion) => {
				this.selected = this.selected.filter((selectedcesion) => selectedcesion.cesionId !== cesion.cesionId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	// setEmisorToElement(row: Cesion) {
	//   let empresaAsociada = this.empresasSource.find(
	//     (Emisor) => Emisor.emisorId == row.emisorId
	//   );
	//   row.emisorAsociado = empresaAsociada;
	// }

	// setTipocesionToElement(row: Cesion) {
	//   let tipocesionAsociado = this.tipocesionSource.find(
	//     (tipo) => tipo.tipocesionId == row.tipocesionId
	//   );
	//   row.nombreTipocesion = tipocesionAsociado.abreviacion;
	// }

	starterPage() {
		this.page.pageNumber = 0;
		this.page.pageSize = 10;
		this.selectedAllItemsInPage[this.page.pageNumber] = false;
	}

	searchElementsByFilter(event) {
		//se toman los valores del filtro que necesite el endpoint de filtro para cesion
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.setPage({ offset: 0 });
	}

	filterConcordance(configCriterias, cesionFilter: CesionFilter, eventFilter): CesionFilter {
		//vaciar del cesionFilter aquellos campos distinto al presnetado en el eventFilter actual, segun el arreglo configCriterias
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				cesionFilter[criteria] = "";
			}
		});
		return cesionFilter;
	}
	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		//llamada generica a los cesion paginados
		this.cesionService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Cesion[];
					this.ref.detectChanges();
					elements.forEach((row) => {});
					this.rowsMantenedor = [...elements];
					this.ref.detectChanges();
					this.setPagefromResponse(this.page, pagedData);
				},
				(error) => {
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en la solicitud";
					this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}

	setPagefromResponse(currentPage: Page, data: PagedResponse<Cesion>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	downloadXml(cesion: Cesion) {
		this.cesionService.getXml(cesion.cesionId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				FileSaver.saveAs(blobXml, cesion.folio + "_" + "cesion.xml");
				this.loading = false;
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = "No fue posible obtener el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
			}
		);
	}

	multipleDocumentDownload(fileType) {
		if (this.selected.length > 0) {
			this.loading = true;
			const cesionIds = this.selected.map(cesion => cesion.cesionId);
			this.getDownloadFilesObservable(cesionIds).subscribe(
                (response) => {
                    const blob = new Blob([response], { type: 'application/zip' });
                    const dateOfDownLoad = this.datePipe.transform(Date.now(), 'dd/MM/yyyy');
                    FileSaver.saveAs(blob, `documentos_${dateOfDownLoad}_${fileType}.zip`);

                    this.currentSwal.icon = "success";
                    this.currentSwal.title = "Descarga de documentos";
                    this.currentSwal.text = "Los documentos seleccionados se han descargado";
                    this.currentSwal.fire();
                },
                (err) => {
					this.loading = false;
					this.ref.detectChanges();
					console.log(err);
                    this.currentSwal.icon = "error";
                    this.currentSwal.title = "Error en exportación";
                    this.currentSwal.text = "No ha sido posible descargar los documentos seleccionados.\nFavor intentar más tarde o contactar a su administrador.";
                    if (err?.error?.errors) {
                        this.currentSwal.text += this.utilities.setErrorMessageFromArray(err.error);
                    }
                    this.currentSwal.fire();					
                },
                () => {
                    this.loading = false;
					this.ref.detectChanges();
                }
            );
		}
		else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	getDownloadFilesObservable(ids: string[]): Observable<Blob> {
		return this.cesionService.getXmlZip(ids);
	}

	getDownloadXmlObservable(id: string): Observable<Response<any>> {
		return this.cesionService.getXml(id);
	}

	convertStreamToFileDownload(responseB64, currentcesion: Cesion, fileType: string, extensionFile: string) {
		const docBlob = this.utilities.convertB64ToBlob(responseB64, fileType);
		FileSaver.saveAs(docBlob, currentcesion.folio + "_cesion." + extensionFile);
	}

	openDocumentSenderModal(modalRef, row?: Cesion) {
		if (row) {
			this.selectedItem = row;
		} else if (this.selected.length > 0) {
			this.selectedItem = undefined;
		} else {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error de Selección";
			this.currentSwal.text = "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'";
			this.currentSwal.fire();
			return;
		}

		this.sendercesionModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});

		this.sendercesionModal.closed.subscribe((res) => {
			this.senderForm.reset();
		});
		this.sendercesionModal.dismissed.subscribe((res) => {
			this.senderForm.reset();
		});
	}

	getXml(cesion: Cesion) {
		this.cesionService.getXml(cesion.cesionId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				let blob = new Blob([blobXml], { type: "text/xml" });
				let fileURL = URL.createObjectURL(blobXml);
				this.popupCenter(fileURL, "Documentos Tributario Electrónico", 600, 800);
				this.loading = false;
			},
			(error) => {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
				this.loading = false;
			},
			() => {
				this.loading = false;
			}
		);
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom},
    height=${h / systemZoom},
    top=${top},
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	exportToExcel() {
		this.getAllRowsByFilter(this.page, this.filter);
	}
	getAllRowsByFilter(currentPageRef: Page, currentFilter: CesionFilter) {
		let fullPage: Page = new Page();
		fullPage.pageSize = currentPageRef.totalElements;
		fullPage.pageNumber = 0;
		fullPage.totalElements = currentPageRef.totalElements;
		fullPage.totalPages = 1;
		this.loading = true;
		this.cesionService.getDataByPage(currentFilter, fullPage).subscribe(
			(result) => {
				let elements = result.data as Cesion[];
				this.ref.detectChanges();
				elements.forEach((row) => {});
				this.loading = false;
				this.ref.detectChanges();
				this.exportExcelData(elements);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al exportar";
				this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
				this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	exportExcelData(arrayToExport: Array<Cesion>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Rut Persona Autorizada"] = row.rutPersonaAutorizada + "-" + row.dvPersonaAutorizada;
			elementToExport["Nombre Persona Autorizada"] = row.nombrePersonaAutorizada;
			elementToExport["Folio Factura"] = row.folio;
			elementToExport["Monto Total"] = row.montoTotal;
			elementToExport["Fecha de Emisión"] = this.datePipe.transform(row.fechaEmision, "dd/MM/yyyy");
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Cesion");
	}

	openTraceShowModal(modalRef, cesion: Cesion) {
		this.cesionToShow = cesion;
		this.loading = true;
		this.cesionService
			.getTrace(this.cesionToShow.cesionId)
			.subscribe(
				(result) => {
					this.trazasCesionToShow = result.data as TrazaCesion[];
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en Trazabilidad";
					this.currentSwal.text = "No es posible obtener la trazabilidad de este documento. Intente mas tarde. ";
					this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);

					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
				}
			)
			.add(() => {
				this.loading = false;
				this.tracesModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			});
	}

	downloadPDF(row: Cesion) {
		this.loading = true;
		this.dteService.getPdf(row.dteId).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, row.folio);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}
	responseToPdfDownload(responseB64, folio) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, folio + "_dte.pdf");
		this.loading = false;
		this.ref.detectChanges();
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	resendCesion(dte: Cesion) {
		this.loading = true;
		var request = new UpdateCesionRequest();
		request.cesionId = dte.cesionId;
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.cesionService.resendCesion(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Estado Sii Actualizado",
					text: "La cesion volverá a ser enviada al servicio de impuestos internos",
				});
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Actualizar Estado Sii",
					text: "No fue posible actualizar el estado sii de la cesion. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
}
